import { dockMessagesEn } from "./dock.messages.en";
import { pricePaneMessagesEn } from "./pricePane.messages.en";
import { tradingMessagesEn } from "./trading.messages.en";
import { a11yMessagesEn } from "./a11y.messages.en";
import { licensingMessagesEn } from "./messages.licensing";
import { capabilityMessagesEn } from "./capability.messages.en";
import { settingsMessagesEn } from "./settings.messages.en";
import { strategyMessagesEn } from "./strategy.messages.en";
export const widgetMessagesEn = {
    "widget.loading": "Loading chart…",
    "widget.noData": "No data available",
    "widget.error": "An error occurred in the chart",
    "widget.title": "VNStock chart",
    "widget.symbol": "Symbol",
    "widget.timeframe": "Timeframe",
    "common.close": "Close",
    "drawing.contextMenuTitle": "Object actions",
    "drawing.copy": "Copy",
    "drawing.paste": "Paste",
    "drawing.bringToFront": "Bring to front",
    "drawing.sendToBack": "Send to back",
    "drawing.bringForward": "Bring forward",
    "drawing.sendBackward": "Send backward",
    "drawing.duplicate": "Duplicate",
    "drawing.selectGroup": "Select group",
    "drawing.deleteGroup": "Delete group",
    "drawing.syncConflictTitle": "Drawing conflict",
    "drawing.syncConflictRemoteWon": "A newer drawing from another chart was applied",
    "drawing.syncConflictDismiss": "Got it",
    "measurement.title": "Measure",
    "measurement.bars": "Bars",
    "measurement.price": "Δ price",
    // Tape Panel (O-01)
    "tape.title": "Tape",
    "tape.close": "Close",
    "tape.filterLabel": "Filter by value",
    "tape.colTime": "Time",
    "tape.colPrice": "Price",
    "tape.colVolume": "Vol",
    "tape.colValue": "Value",
    "tape.loading": "Loading...",
    "tape.empty": "No data yet",
    "tape.all": "All",
    "tape.orderCount": "orders",
    "tape.billions": "B",
    "tape.sideBuy": "B",
    "tape.sideSell": "S",
    "tape.sideUnknown": "?",
    // Advisory Panel (I-01)
    "advisory.title": "AI Advisory",
    "advisory.close": "Close",
    "advisory.refresh": "Refresh analysis",
    "advisory.decision.STRONG_BUY": "STRONG BUY",
    "advisory.decision.BUY": "BUY",
    "advisory.decision.HOLD": "HOLD",
    "advisory.decision.SELL": "SELL",
    "advisory.decision.STRONG_SELL": "STRONG SELL",
    "advisory.confidence": "Confidence",
    "advisory.agent.whale": "Whale",
    "advisory.agent.tech": "Technical",
    "advisory.agent.risk": "Risk",
    "advisory.agent.sentiment": "Sentiment",
    "advisory.expand": "View explanation",
    "advisory.collapse": "Collapse",
    "advisory.showSummary": "▼ Show AI summary",
    "advisory.hideSummary": "▲ Hide summary",
    "advisory.empty": "Press ↻ to get AI advisory",
    "advisory.action": "Action",
    "advisory.risk": "Risk",
    "advisory.score": "Score",
    "advisory.components": "Analysis components",
    "advisory.queued": "Generating analysis…",
    "advisory.provider": "Source",
    // ── Indicator labels (CE15 + CE16) ──────────────────────────────────
    "indicator.ma": "Moving Average",
    "indicator.candlestick": "Candlestick",
    "indicator.hollowCandle": "Hollow Candle",
    "indicator.ohlc": "OHLC Bar",
    "indicator.heikinAshi": "Heikin-Ashi",
    "indicator.line": "Line",
    "indicator.area": "Area",
    "indicator.bar": "Bar",
    "indicator.ema": "Exponential Moving Average",
    "indicator.bollingerBand": "Bollinger Bands",
    "indicator.volume": "Volume",
    "indicator.histogram": "Histogram",
    "indicator.whale": "Whale Flow",
    "indicator.cvdApprox": "CVD Approx",
    "indicator.cvdRealtime": "CVD Realtime",
    "indicator.rsi": "Relative Strength Index",
    "indicator.macd": "MACD",
    "indicator.strengthElder": "Elder Strength",
    "indicator.bbi": "Bull Bear Index",
    "indicator.sar": "Parabolic SAR",
    "indicator.obv": "On Balance Volume",
    "indicator.wr": "Williams %R",
    "indicator.vr": "Volume Ratio",
    "indicator.kdj": "KDJ Oscillator",
    "indicator.cci": "Commodity Channel Index",
    "indicator.dmi": "Directional Movement Index",
    "indicator.bias": "Bias Ratio",
    "indicator.brar": "Bull Bear Ratio",
    "indicator.mtm": "Momentum",
    "indicator.emv": "Ease of Movement",
    "indicator.ao": "Awesome Oscillator",
    "indicator.roc": "Rate of Change",
    "indicator.trix": "Triple EMA",
    "indicator.dma": "Differential MA",
    "indicator.pvt": "Price Volume Trend",
    "indicator.psy": "Psychological Line",
    "indicator.cr": "CR Indicator",
    "indicator.strengthRelative": "Relative Strength (RS)",
    "indicator.smfi": "Smart Money Flow Index",
    "indicator.wyckoffWave": "Wyckoff Wave",
    "indicator.wma": "Weighted Moving Average",
    "indicator.vwma": "Volume Weighted Moving Average",
    "indicator.hma": "Hull Moving Average",
    "indicator.dema": "Double Exponential Moving Average",
    "indicator.tema": "Triple Exponential Moving Average",
    "indicator.maRibbon": "MA Ribbon",
    "indicator.ichimoku": "Ichimoku Cloud",
    "indicator.supertrend": "Supertrend",
    "indicator.keltner": "Keltner Channels",
    "indicator.donchian": "Donchian Channels",
    "indicator.chaikinVol": "Chaikin Volatility",
    "indicator.stdDev": "Standard Deviation",
    "indicator.hv": "Historical Volatility",
    "indicator.ci": "Choppiness Index",
    "indicator.cmf": "Chaikin Money Flow", "indicator.chaikinOscillator": "Chaikin Oscillator", "indicator.chaikinOscillator.description": "Money flow momentum: the faster EMA of CMF minus the slower one, so it shows whether inflows are strengthening or fading.",
    "indicator.mfi": "Money Flow Index",
    "indicator.volOsc": "Volume Oscillator",
    "indicator.vwap": "Session VWAP",
    "indicator.anchoredVwap": "Anchored VWAP",
    "indicator.alligator": "William Alligator",
    "indicator.fractals": "Fractals",
    "indicator.gator": "Gator Oscillator",
    "indicator.ac": "Accelerator Oscillator",
    "indicator.pivotStandard": "Pivot Points Standard",
    "indicator.pivotHighLow": "Pivot Points High/Low",
    "indicator.marketProfile": "Market Profile (TPO)",
    "indicator.volumeProfile": "Volume Profile",
    "indicator.footprint": "Footprint Chart",
    "indicator.deltaProfile": "Delta Profile",
    // ── Settings labels ────────────────────────────────────────────────
    "settings.period": "Period",
    // W1.2/A2: ngưỡng so dấu của histogram series.
    "settings.baseAt": "Base level",
    "settings.fillMode": "Fill",
    "settings.fillMode.none": "None",
    "settings.fillMode.solid": "Solid",
    "settings.fillMode.fade": "Gradient",
    "settings.fillOpacity": "Fill Opacity",
    "settings.fillColor": "Fill Color",
    "settings.compareSymbol": "Compare Symbol",
    "settings.thresholdPercent": "Threshold %",
    "settings.stdDev": "Std Deviation",
    "settings.fast": "Fast",
    "settings.slow": "Slow",
    "settings.signal": "Signal",
    "settings.thresholdUsd": "Threshold USD",
    "settings.afStep": "AF Step",
    "settings.afMax": "AF Max",
    "settings.signalPeriod": "Signal Period",
    "settings.fastPeriod": "Fast Period",
    "settings.slowPeriod": "Slow Period",
    "settings.m1": "M1",
    "settings.m2": "M2",
    "settings.m3": "M3",
    "settings.m4": "M4",
    "settings.remove": "Remove",
    "settings.deletePane": "Delete pane",
    "settings.paneName": "Rename Pane",
    "settings.addIndicator": "Add indicator",
    "settings.indicatorType": "Type",
    "settings.layout": "Layout",
    "settings.indicators": "Indicators",
    "settings.theme": "Theme",
    "settings.reset": "Reset",
    "settings.licensing": "Licensing",
    "licensing.title": "Licensing & Key Configuration",
    "licensing.desc": "Manually enter a Personal Access Token (PAT) key to restore or upgrade chart services when the default key expires.",
    "licensing.inputLabel": "Personal Access Token (PAT) Key",
    "licensing.save": "Update Key",
    "licensing.clear": "Reset to Default",
    "licensing.statusActive": "Active",
    "licensing.statusExpired": "Expired or Invalid",
    "licensing.statusSuspended": "Suspended",
    "licensing.plan": "Current Plan",
    "licensing.status": "Connection Status",
    "licensing.domainWhitelist": "Whitelisted Domains",
    "licensing.tenant": "Owner (Tenant)",
    "licensing.patPlaceholder": "Paste vni_... key here...",
    "licensing.successUpdate": "License key updated successfully!",
    "licensing.successClear": "Restored default license configuration.",
    "licensing.offlineActivated": "Activated {tier} offline (expires {date}).",
    "licensing.offlineInvalid": "Invalid or expired signed key.",
    "licensing.legacySaved": "Key saved. Legacy format — requires server validation; offline Pro needs a signed vni1.* key.",
    "licensing.legacyHint": "Saved key is legacy format and cannot unlock Pro offline.",
    "settings.timezone": "System Timezone",
    "settings.open": "Settings",
    "settings.resetDefaults": "Reset defaults",
    "settings.resetLayout": "Reset layout",
    "settings.overlayTimeframe": "Overlay Timeframe",
    "settings.overlayStyle": "Overlay Style",
    "settings.overlayNone": "None",
    "settings.styleCandle": "Candle",
    "settings.styleHollowBox": "Hollow Box",
    "settings.styleStepLine": "Step Line",
    "settings.styleArea": "Area",
    "settings.workspaceJson": "Workspace JSON Import/Export",
    "settings.workspaceJsonNote": "Export or import your full workspace layout including all panes, drawings, and settings.",
    "settings.exportWorkspace": "Export Workspace",
    "settings.importWorkspace": "Import Workspace",
    "settings.importSuccess": "Workspace imported successfully!",
    "settings.sub.rsiLine": "RSI Line",
    "settings.sub.rsiOverbought": "Overbought (70)",
    "settings.sub.rsiMiddle": "Middle (50)",
    "settings.sub.rsiOversold": "Oversold (30)",
    "settings.sub.macd": "MACD Line",
    "settings.sub.signal": "Signal Line",
    "settings.sub.diverge": "Histogram",
    "settings.sub.bbMiddle": "Middle Band",
    "settings.sub.bbUpper": "Upper Band",
    "settings.sub.bbLower": "Lower Band",
    "settings.sub.k": "K Line",
    "settings.sub.d": "D Line",
    "settings.sub.j": "J Line",
    "settings.sub.plusDI": "+DI",
    "settings.sub.minusDI": "-DI",
    "settings.sub.adx": "ADX",
    "settings.sub.ar": "AR",
    "settings.sub.br": "BR",
    "settings.sub.bull": "Bull Power",
    "settings.sub.bear": "Bear Power",
    "settings.sub.mtm": "MTM",
    "settings.sub.emv": "EMV",
    "settings.sub.trix": "TRIX",
    "settings.sub.ddd": "DDD",
    "settings.sub.ama": "AMA",
    "settings.sub.psy": "PSY",
    "settings.sub.cr": "CR",
    "settings.sub.ma1": "MA1",
    "settings.sub.ma2": "MA2",
    "settings.sub.ma3": "MA3",
    "settings.sub.ma4": "MA4",
    // ── Drawing tools ──────────────────────────────────────────────────
    "tool.trendLine": "Trend Line",
    "tool.hLine": "Horizontal Line",
    "tool.vLine": "Vertical Line",
    "tool.ray": "Ray",
    "tool.extendedLine": "Extended Line",
    "tool.fibonacci": "Fibonacci",
    "tool.channel": "Channel",
    "tool.text": "Text Note",
    "tool.rectangle": "Rectangle",
    "tool.circle": "Circle",
    "tool.ellipse": "Ellipse",
    "tool.triangle": "Triangle",
    "tool.arrow": "Arrow",
    "tool.polyline": "Polyline",
    "tool.callout": "Callout",
    "tool.priceLabel": "Price Label",
    "tool.priceRange": "Price Range",
    "tool.dateRange": "Date Range",
    "tool.barsCount": "Bars Count",
    "tool.fibChannel": "Fib Channel",
    "tool.fibSpeedResistanceFan": "Fib Speed/Fan",
    "tool.trendBasedFibTime": "Trend Fib Time",
    "tool.fibCircles": "Fib Circles",
    "tool.fibSpiral": "Fib Spiral",
    "tool.fibSpeedResistanceArcs": "Fib Speed Arcs",
    "tool.fibWedge": "Fib Wedge",
    "tool.pitchfan": "Pitchfan",
    "tool.gannFan": "Gann Fan",
    "tool.gannBox": "Gann Box",
    "tool.gannSquare": "Gann Square",
    "tool.gannSquareFixed": "Gann Square Fixed",
    "tool.cyclicLines": "Cyclic Lines",
    "tool.timeCycles": "Time Cycles",
    "tool.sineLine": "Sine Line",
    "tool.xabcdPattern": "XABCD Pattern",
    "tool.cypherPattern": "Cypher Pattern",
    "tool.headAndShoulders": "Head & Shoulders",
    "tool.trianglePattern": "Triangle Pattern",
    "tool.threeDrivesPattern": "Three Drives",
    "tool.elliottImpulse": "Elliott Impulse",
    "tool.elliottCorrection": "Elliott Correction",
    "tool.elliottTriangle": "Elliott Triangle",
    "tool.elliottDoubleCombo": "Elliott Double Combo",
    "tool.elliottTripleCombo": "Elliott Triple Combo",
    "tool.fibExtension": "Fib Extension",
    "tool.parallelChannel": "Parallel Channel",
    "tool.pitchfork": "Andrew's Pitchfork",
    "tool.abcdPattern": "ABCD Pattern",
    "tool.fibArc": "Fibonacci Arc",
    "tool.fibTimeZone": "Fibonacci Time Zone",
    "tool.regressionChannel": "Regression Channel",
    "tool.cursor": "Cursor",
    "tool.crosshair": "Crosshair",
    "tool.longPosition": "Long Position",
    "tool.shortPosition": "Short Position",
    "tool.dateAndPriceRange": "Date & Price Range",
    // CE22: Drawing Tools Pack 1
    "tool.disjointChannel": "Disjoint Channel",
    "tool.flatTopBottom": "Flat Top/Bottom",
    "tool.schiffPitchfork": "Schiff Pitchfork",
    "tool.modifiedSchiff": "Modified Schiff",
    "tool.insidePitchfork": "Inside Pitchfork",
    "tool.gannFixed": "Gann Fixed",
    "tool.trendAngle": "Trend Angle",
    "tool.infoLine": "Info Line",
    // CE23: Drawing Tools Pack 2
    "tool.brush": "Brush",
    "tool.highlighter": "Highlighter",
    "tool.eraser": "Eraser",
    "tool.curve": "Curve",
    "tool.arc": "Arc",
    "tool.path": "Path",
    "tool.polygon": "Polygon",
    "tool.rotatedRectangle": "Rotated Rectangle",
    "tool.brush.description": "Freehand drawing with brush strokes",
    "tool.highlighter.description": "Semi-transparent highlight strokes",
    "tool.eraser.description": "Erase freehand strokes",
    "tool.curve.description": "Quadratic Bezier curve through 3 points",
    "tool.arc.description": "Circular arc through 3 points",
    "tool.path.description": "Multi-point path, double-click to finish",
    "tool.polygon.description": "Closed polygon with fill",
    "tool.rotatedRectangle.description": "Freely rotated rectangle",
    // CE24: Drawing Tools Pack 3
    "tool.anchoredVwap": "Anchored VWAP",
    "tool.iconMarker": "Icon/Emoji Marker",
    "tool.ghostFeed": "Ghost Feed",
    "tool.barsPattern": "Bars Pattern",
    "tool.crossLine": "Cross Line",
    "tool.datePriceRange": "Date/Price Range",
    "tool.anchoredVwap.description": "VWAP calculated from custom anchor point",
    "tool.iconMarker.description": "Place icon or emoji on chart",
    "tool.ghostFeed.description": "Overlay chart from another symbol/timeframe",
    "tool.barsPattern.description": "Find similar candlestick patterns",
    "tool.crossLine.description": "Crosshair showing price and time",
    "tool.datePriceRange.description": "Measure: price change %, bars, days, R:R, angle",
    "tool.group.cursor": "Cursor",
    "tool.group.lines": "Lines",
    "tool.group.channels": "Channels",
    "tool.group.fibonacci": "Fibonacci",
    "tool.group.gann": "Gann",
    "tool.group.pitchfork": "Pitchfork",
    "tool.group.shapes": "Shapes",
    "tool.group.measurement": "Measurement",
    "tool.group.patterns": "Patterns",
    "tool.group.elliott": "Elliott Waves",
    "tool.group.cycles": "Cycles",
    "tool.group.annotation": "Annotation",
    "tool.group.orderflow": "Order Flow",
    "tool.group.icons": "Icons",
    "tool.group.advancedLines": "Advanced Lines",
    "tool.group.drawing": "Drawing",
    // ── Drawing UI ─────────────────────────────────────────────────────
    "drawing.stroke": "Stroke",
    "drawing.selectIcon": "Select Icon",
    "drawing.iconSize": "Icon Size",
    "drawing.fill": "Fill",
    "drawing.strokeWidth": "Stroke Width",
    "drawing.lineStyle": "Line Style",
    "drawing.opacity": "Opacity",
    "drawing.solid": "Solid",
    "drawing.dashed": "Dashed",
    "drawing.dotted": "Dotted",
    "drawing.lock": "Lock",
    "drawing.unlock": "Unlock",
    "drawing.clone": "Clone",
    "drawing.hide": "Hide",
    "drawing.show": "Show",
    "drawing.openProperties": "Properties",
    "drawing.delete": "Delete",
    "drawing.close": "Close",
    "drawing.hideToolbar": "Hide Toolbar",
    "drawing.showToolbar": "Show Toolbar",
    "drawing.handle.delete": "Delete",
    "drawing.handle.clone": "Clone",
    "drawing.handle.lock": "Lock",
    "drawing.handle.unlock": "Unlock",
    "drawing.drawingsList": "Drawings List",
    "drawing.drawingsListEmpty": "No drawings yet.",
    "drawing.visible": "Visible",
    "drawing.hidden": "Hidden",
    "drawing.locked": "Locked",
    "drawing.unlocked": "Unlocked",
    "drawing.dockTitle": "Drawing Dock",
    "drawing.dockProperties": "Properties",
    "drawing.dockObjects": "Objects",
    "drawing.dockTemplates": "Templates",
    "drawing.dockPropertiesEmpty": "Select a drawing to edit properties.",
    "drawing.dockObjectsEmpty": "No drawings in current chart.",
    "drawing.dockTemplatesEmpty": "Templates tab coming soon.",
    "drawing.dock.toggle": "Drawing Dock",
    "drawing.dock.toggleShortcut": "Ctrl+Shift+L",
    "drawing.dock.resize": "Resize",
    "drawing.dock.title": "Drawing Manager",
    "drawing.dock.close": "Close",
    "drawing.dock.properties": "Properties",
    "drawing.dock.objects": "Objects List",
    "drawing.dock.templates": "Templates",
    "drawing.dock.emptyProperties": "No object selected",
    "drawing.dock.emptyObjects": "No drawings on the chart yet",
    "drawing.dock.emptyTemplates": "No templates for this tool yet",
    "drawing.rename": "Rename",
    "drawing.saveFailed": "Could not save drawings (storage full)",
    "drawing.importFailed": "Could not import drawings file",
    "drawing.edit": "Edit",
    "drawing.properties": "Properties",
    "drawing.searchPlaceholder": "Search drawings…",
    "drawing.list.title": "Current Drawings",
    "drawing.list.empty": "No drawings",
    "drawing.list.visible": "Show",
    "drawing.list.hidden": "Hide",
    "drawing.list.locked": "Lock",
    "drawing.list.unlocked": "Unlock",
    "drawing.list.selected": "Selected",
    "drawing.list.delete": "Delete",
    "drawing.toolbar.deleteAll": "Delete all",
    "drawing.toolbar.lockAll": "Lock all",
    "drawing.toolbar.unlockAll": "Unlock all",
    "drawing.toolbar.hideAll": "Hide all",
    "drawing.toolbar.showAll": "Show all",
    "drawing.toolbar.batchColor": "Change color for all",
    "drawing.toolbar.selectedCount": "{count} selected",
    "drawing.toolbar.dragHint": "Drag to move toolbar",
    "drawing.toolbar.all": "All",
    "drawing.toolbar.pickColor": "Pick color",
    "drawing.toolbar.strokeWidth": "Stroke width",
    "drawing.toolbar.lineStyle": "Line style",
    "drawing.toolbar.solid": "Solid",
    "drawing.toolbar.dashed": "Dashed",
    "drawing.toolbar.dotted": "Dotted",
    "drawing.toolbar.point": "Point",
    "drawing.resourcesSuspended": "Chart resources suspended ({reason})",
    "drawing.selection.duplicate": "Duplicate",
    "drawing.selection.group": "Group",
    "tool.premiumLocked": "Upgrade to Pro",
    "toolbar.favoriteTools": "Favorites",
    "drawing.pointLegendTitle": "Component Points",
    "drawing.pointLegendEmpty": "Select a drawing with semantic points.",
    "drawing.pointLegendClear": "Clear focus",
    "drawing.inspectorTitle": "Drawing Inspector",
    "drawing.inspector.saveStyle": "Save as default",
    "drawing.inspector.rrTitle": "Trade Entry",
    "drawing.inspector.rrEntry": "Entry",
    "drawing.inspector.rrStop": "Stop",
    "drawing.inspector.rrTarget": "Target",
    "drawing.inspector.segmentsTitle": "Segments",
    "drawing.coordinatesTitle": "Coordinates",
    "drawing.priceLabel": "Price",
    "drawing.text.bold": "Bold",
    "drawing.text.italic": "Italic",
    "drawing.text.alignLeft": "Align Left",
    "drawing.text.alignCenter": "Center",
    "drawing.text.alignRight": "Align Right",
    "drawing.text.background": "Background",
    "drawing.text.border": "Border",
    "drawing.text.radius": "Radius",
    "drawing.text.shadow": "Shadow",
    "drawing.callout.tail": "Tail",
    "drawing.priceLabel.anchored": "Anchored to axis",
    "drawing.icon.search": "Search icons…",
    "drawing.icon.recent": "Recent",
    "drawing.icon.custom": "Custom URL",
    "drawing.timeLabel": "Time",
    "drawing.templatesTitle": "Templates",
    "drawing.templatesSave": "Save Template",
    "drawing.templatesDelete": "Delete Template",
    "drawing.templatesLoad": "Load Template",
    "drawing.templatesNamePlaceholder": "New template name...",
    "drawing.fibLevelsTitle": "Fibonacci Levels",
    "drawing.fibAddLevel": "Add Level",
    "drawing.fibRemoveLevel": "Remove",
    "drawing.toggleList": "Drawing List",
    "drawing.textEditorTitle": "Edit Text",
    "drawing.textEditorLabel": "Content",
    "drawing.textEditorPlaceholder": "Enter text content",
    "drawing.textEditorEdit": "Edit text",
    "drawing.textEditorSave": "Save",
    "drawing.textEditorCancel": "Cancel",
    "drawing.textEditorEmpty": "No content",
    "drawing.magnetSensitivity": "Magnet sensitivity",
    "drawing.magnet.weak": "Weak",
    "drawing.magnet.normal": "Normal",
    "drawing.magnet.strong": "Strong",
    "drawing.magnet.off": "Off",
    "drawing.lineType.label": "Line type",
    "drawing.lineType.trendLine": "Line segment",
    "drawing.lineType.ray": "Ray (extends right)",
    "drawing.lineType.extendedLine": "Extended line",
    "drawing.gannFan.label": "Gann Fan",
    "drawing.measure.priceDeltaPrefix": "Δ price: ",
    "drawing.measure.barsLabel": "bars",
    "drawing.fib.levelsTitle": "Fibonacci Levels",
    "drawing.fib.addLevel": "Add level",
    "drawing.fib.removeLevel": "Remove",
    "drawing.elliott.impulse": "Elliott Impulse",
    "drawing.elliott.correction": "Elliott Correction",
    "drawing.elliott.triangle": "Elliott Triangle",
    "drawing.elliott.doubleCombo": "Elliott Double Combo",
    "drawing.elliott.tripleCombo": "Elliott Triple Combo",
    "drawing.pattern.xabcd": "XABCD Pattern",
    "drawing.pattern.cypher": "Cypher Pattern",
    "drawing.pattern.headAndShoulders": "Head & Shoulders",
    "drawing.pattern.triangle": "Triangle Pattern",
    "drawing.pattern.threeDrives": "Three Drives",
    "drawing.pattern.ratioLabel": "Ratio",
    "drawing.fib.channel": "Fibonacci Channel",
    "drawing.fib.speedResistanceFan": "Fib Speed/Fan",
    "drawing.fib.trendBasedFibTime": "Trend Fib Time",
    "drawing.fib.circles": "Fib Circles",
    "drawing.fib.spiral": "Fib Spiral",
    "drawing.fib.speedResistanceArcs": "Fib Speed Arcs",
    "drawing.fib.wedge": "Fib Wedge",
    "drawing.fib.pitchfan": "Pitchfan",
    "drawing.gann.box": "Gann Box",
    "drawing.gann.squareFixed": "Gann Square Fixed",
    "drawing.gann.square": "Gann Square",
    "drawing.cycle.cyclicLines": "Cyclic Lines",
    "drawing.cycle.timeCycles": "Time Cycles",
    "drawing.cycle.sineLine": "Sine Line",
    "drawing.cycle.count": "Cycle Count",
    "drawing.cycle.amplitude": "Amplitude",
    "drawing.selected": "Selected",
    "drawing.exportJson": "Export JSON",
    "drawing.importJson": "Import JSON",
    "drawing.clearAll": "Clear All",
    // ── Alert ──────────────────────────────────────────────────────────
    "drawing.alert.title": "🔔 Alert",
    "drawing.alert.enabled": "Enabled",
    "drawing.alert.direction": "Trigger direction",
    "drawing.alert.cooldown": "Cooldown (seconds)",
    "drawing.alert.crossAbove": "Cross above",
    "drawing.alert.crossBelow": "Cross below",
    "drawing.alert.either": "Either",
    "alert.crossAbove": "Cross above",
    "alert.crossBelow": "Cross below",
    "alert.at": "At",
    "alert.dismiss": "Dismiss",
    // ── Replay ─────────────────────────────────────────────────────────
    "replay.controls": "Replay Controls",
    "replay.play": "Play",
    "replay.pause": "Pause",
    "replay.stop": "Stop",
    "replay.rewind": "Rewind",
    "replay.jumpLatest": "Jump to latest",
    "replay.stepBack": "Step back",
    "replay.stepForward": "Step forward",
    "replay.speed": "Speed",
    "replay.interval": "Interval",
    "replay.interval.source": "Source bars",
    "replay.interval.1s": "1s",
    "replay.interval.1m": "1 min",
    "replay.interval.5m": "5 min",
    "replay.interval.15m": "15 min",
    "replay.interval.1h": "1 hour",
    "replay.progress": "{current}/{total} bars",
    "replay.fromHere": "Replay from here",
    "replay.closeBar": "Close replay",
    "replay.mode": "Replay mode",
    "replay.hintClickBar": "Click a bar: set start",
    "replay.cutHint": "Click a bar to start replay",
    "replay.jumpToBar": "Jump to bar",
    "replay.cutBadge": "Cut at {date}",
    "replay.seek": "Seek bar",
    "replay.speedLabel": "Replay speed",
    "replay.intervalLabel": "Interval",
    "replay.modeLabel": "Replay scope",
    "replay.mode.single": "1 chart",
    "replay.mode.all": "All charts",
    "replay.toggle": "Replay",
    "replay.speedUnit": "x",
    "replay.analyticsTrades": "{count}T",
    "replay.analyticsWinRate": "{rate}%",
    "replay.analyticsProfitFactor": "{pf}PF",
    "replay.analyticsProfitFactorInf": "∞",
    "replay.analyticsDrawdown": "{dd}%DD",
    // ── Header ──────────────────────────────────────────────────────────
    "header.search": "Search",
    "header.settings": "Settings",
    "header.fullscreen": "Fullscreen",
    "header.snapshot": "Snapshot", "header.csvExport": "Export CSV", "header.csvExportTitle": "Export CSV data",
    "header.saveTemplate": "Save Template",
    "header.loadTemplate": "Load Template",
    "header.alerts": "Alerts",
    "header.systemMenu": "System Menu",
    "header.compare": "Compare",
    "header.chartType": "Select chart type",
    "header.chartTypeOptions": "Chart type options",
    "header.compareTitle": "Compare symbols",
    "header.searchTitle": "Quick Search",
    "header.settingsTitle": "Settings",
    "header.fullscreenTitle": "Full Screen Mode",
    "header.snapshotTitle": "Take a Snapshot",
    "header.saveTemplateTitle": "Save Layout Template",
    "header.loadTemplateTitle": "Load Layout Template",
    "header.alertsTitle": "Manage Alerts",
    "header.systemMenuTitle": "Open System Menu",
    "header.upgradePro": "Pro",
    "header.timeframe": "Timeframe",
    "header.exitFullscreen": "Exit fullscreen",
    // ── Mobile ──────────────────────────────────────────────────────────
    "mobile.systemMenu": "System Menu",
    "mobile.upgradePro": "Upgrade Pro",
    "mobile.searchSymbol": "Search symbol",
    // ── Paper Trading ──────────────────────────────────────────────────
    "paperTrading.title": "Paper Trading",
    "paperTrading.hint": "Click chart while replaying to open a paper position.",
    "paperTrading.report": "Replay Report",
    "paperTrading.finalized": "Finalized",
    "paperTrading.total": "Total",
    "paperTrading.wins": "Wins",
    "paperTrading.losses": "Losses",
    "paperTrading.winRate": "Win Rate",
    "paperTrading.realized": "Realized PnL",
    "paperTrading.avgPnl": "Avg PnL",
    "paperTrading.unrealized": "Unrealized",
    "paperTrading.avgBarsHeld": "Avg Bars Held",
    "paperTrading.bestTrade": "Best Trade",
    "paperTrading.worstTrade": "Worst Trade",
    "paperTrading.journal": "Journal",
    "paperTrading.barsUnit": "bars",
    "paperTrading.position": "Position",
    "paperTrading.entry": "Entry",
    "paperTrading.reset": "Reset journal",
    "paperTrading.empty": "No paper trades yet.",
    "paperTrading.open": "Open",
    "paperTrading.closed": "Closed",
    // ── Toolbar ────────────────────────────────────────────────────────
    "toolbar.candleType": "Candle Type",
    "toolbar.recent": "Recent Tools",
    "toolbar.searchPlaceholder": "Search tools…",
    "toolbar.searchNoResults": "No matching tools",
    "toolbar.favorite": "Favorites",
    "toolbar.unfavorite": "Unfavorite",
    "toolbar.hideFavoritesBar": "Hide favorites bar",
    "toolbar.showFavoritesBar": "Show favorites bar",
    "toolbar.toggleFavoritesBar": "Toggle favorites toolbar",
    "toolbar.unpinFromFavorites": "Remove from favorites",
    "toolbar.moreTools": "Favorite Tools",
    "toolbar.utility.zoomIn": "Zoom In",
    "toolbar.utility.zoomOut": "Zoom Out",
    "chart.nav.panLeft": "Scroll Left",
    "chart.nav.panRight": "Scroll Right",
    "chart.nav.fitToData": "Fit to Data",
    "chart.nav.toggleSolo": "Focus Chart",
    "chart.nav.restoreGrid": "Restore Grid",
    "chart.nav.toolbarLabel": "Chart navigation",
    "toolbar.title": "Drawing Toolbar",
    "toolbar.dock": "Dock toolbar",
    "toolbar.undock": "Undock toolbar",
    "toolbar.drawingTools": "Drawing Tools",
    "toolbar.selectChart": "Select chart",
    "toolbar.lock": "Lock toolbar",
    "toolbar.unlock": "Unlock toolbar",
    "toolbar.expand": "Expand",
    "toolbar.collapse": "Collapse",
    "toolbar.collapseGroup": "Collapse {group}",
    "toolbar.expandGroup": "Expand {group}",
    "toolbar.actions": "Actions",
    "toolbar.dangerousActions": "Clear actions",
    // ── Candle/Chart types ─────────────────────────────────────────────
    "candleType.candlestick": "Candlestick",
    "candleType.hollow": "Hollow Candle",
    "candleType.ohlc": "OHLC Bar",
    "candleType.heikinashi": "Heikin-Ashi",
    "candleType.line": "Line Chart",
    "candleType.area": "Area Chart",
    "chartType.candlestick": "Candlestick",
    "chartType.hollow": "Hollow Candle",
    "chartType.ohlc": "OHLC Bar",
    "chartType.heikinashi": "Heikin Ashi",
    "chartType.line": "Line",
    "chartType.area": "Area",
    // ── Library labels ─────────────────────────────────────────────────
    "library.range.1d": "1D",
    "library.range.5d": "5D",
    "library.range.1m": "1M",
    "library.range.3m": "3M",
    "library.range.ytd": "YTD",
    "library.range.1y": "1Y",
    "library.range.all": "All",
    "library.pricePaneLabel": "Price",
    "library.volumePaneLabel": "Volume",
    "library.momentumPaneLabel": "RSI+MACD",
    "library.orderflowPaneLabel": "Order Flow",
    "library.strengthPaneLabel": "Strength",
    "library.genericPaneLabel": "Pane {index}",
    // ── Symbol Search ────────────────────────────────────────────────
    "symbolSearch.placeholder": "Search symbol...",
    "symbolSearch.switch": "Switch",
    "whale.title": "Whale Flow",
    "whale.whale": "Whale",
    "whale.shark": "Shark",
    "whale.small": "Small",
    "whale.buy": "Buy",
    "whale.sell": "Sell",
    "whale.net": "Net",
    "whale.alerts": "Alerts",
    // ── Settings (from demo PaneSettingsModal) ───────────────────────
    "settings.maxVisibleBars": "Max visible bars",
    "settings.maxVisibleBarsNote": "Limit bars shown when zooming out.",
    "settings.zoomSpeed": "Zoom speed",
    "settings.zoomSpeedNote": "Controls how fast the chart zooms per scroll step (1.05 slow - 1.3 fast).",
    "settings.showNonTradingDays": "Show non-trading days",
    "settings.showNonTradingDaysNote": "Show holidays and weekends on X axis.",
    "settings.datasource": "Data source",
    "settings.datasourceTitle": "Configure data source",
    "settings.dataAdapter.binance": "Binance",
    "settings.dataAdapter.local": "Offline data",
    "settings.headerTitleActive": "Chart Settings — {symbol} · {timeframe}",
    "settings.activeBadge": "Active chart",
    "settings.applyToAll": "Apply to All",
    "settings.applyToAllNote": "Copy appearance & style to all charts (symbol, panes and scale modes are kept)",
    "settings.applyToAllDone": "Applied appearance to {count} chart(s)",
    "settings.applyIndicatorsToAll": "Apply indicators to all charts",
    // ── Profile / Account ────────────────────────────────────────────
    "profile.menu": "Account",
    "profile.login": "Login",
    "profile.register": "Register",
    "profile.upgrade": "⭐ Upgrade account",
    "profile.settings": "Account settings",
    "profile.logout": "Logout",
    // ── Data Source ──────────────────────────────────────────────────
    "dataSource.label": "Data source",
    "dataSource.demo": "Offline",
    "dataSource.binanceOnline": "Binance",
    "dataSource.binanceOffline": "Offline",
    "dataSource.vninvest": "VNInvest",
    "dataSource.switch": "Switch source",
    // ── Library / Status ─────────────────────────────────────────────
    "library.backfillingHistory": "Loading more history…",
    "library.loadingPriceData": "Loading data…",
    "library.loadingRealData": "Loading live data…",
    "common.liveBinance": "● LIVE · Binance",
    "common.offlineFallback": "⚠ Offline fallback",
    "common.loading": "↻ Loading…",
    "common.binanceLoading": "Loading Binance data…",
    "common.binanceLiveLoading": "Loading live data from Binance…",
    "common.canvasInitializing": "Initializing canvas…",
    "common.chartInitializing": "Initializing chart...",
    "common.compare": "Compare",
    "compare.existing": "Compared symbols",
    "compare.add": "Add",
    "compare.remove": "Remove",
    "compare.normalize": "% Change",
    "compare.absolute": "Price",
    "compare.hide": "Hide",
    "compare.show": "Show",
    "compare.searchPlaceholder": "Search symbol...",
    "compare.title": "Compare symbols",
    "compare.currentSymbol": "Current",
    "compare.peekMode": "Peek mode",
    "common.replay": "Replay",
    "common.upgrade": "Upgrade",
    "common.script": "Script",
    "common.alert": "Alert",
    "common.trade": "Trade",
    "common.panes": "Panes",
    "common.bars": "bars",
    "common.source": "Data source",
    "common.range": "Range",
    "common.status": "Status",
    // ── Theme ────────────────────────────────────────────────────────
    "theme.light": "Light mode",
    "theme.dark": "Dark mode",
    "theme.switchToLight": "Switch to light",
    "theme.switchToDark": "Switch to dark",
    // ── Timezone ─────────────────────────────────────────────────────
    "timezone.hcm": "Vietnam (ICT - UTC+7)",
    "timezone.utc": "UTC",
    "timezone.ny": "New York (EST/EDT)",
    "timezone.london": "London (GMT/BST)",
    // ── Settings Upgrade ──────────────────────────────────────────────
    "settings.dialogKicker": "Settings",
    "settings.dialogClose": "Close settings dialog",
    "settings.layoutKicker": "Layout",
    "settings.managePanes": "Manage panes",
    "settings.maxVisible": "Maximum visible panes",
    "settings.addPane": "+ Add pane",
    "settings.hide": "Hide",
    "settings.restore": "Restore",
    "settings.indicatorKicker": "Indicators",
    "settings.indicatorEditor": "Pane editor",
    "settings.visible": "Visible",
    "settings.yAxis": "Y axis",
    "settings.yAxisLeft": "Left",
    "settings.yAxisRight": "Right",
    "settings.comparison": "Compared Symbols",
    "settings.lineStyle": "Style",
    "settings.lineStyleSolid": "Solid",
    "settings.lineStyleDashed": "Dashed",
    "settings.lineStyleDotted": "Dotted",
    "settings.fillArea": "Fill Area",
    "settings.normalizeToBaseline": "% Change",
    "settings.noPane": "No panes are available.",
    "settings.themeKicker": "Theme",
    "settings.appearanceShell": "Appearance",
    "settings.priceMarkers": "Price marker",
    "settings.priceMarkersNote": "Turn this on to show price markers on the selected drawing.",
    "settings.whale": "Whale Orders",
    "settings.whaleNote": "Display large buy/sell orders on the price chart.",
    "settings.whaleThreshold": "Order threshold (VND)",
    "settings.cvd": "CVD (Cumulative Volume Delta)",
    "settings.cvdNote": "Display CVD indicator on the chart.",
    "settings.cvdMode": "CVD Mode",
    "settings.cvdOscillator": "Oscillator",
    "settings.cvdHistogram": "Histogram",
    "settings.alertAudioEnabled": "Alert Sound Chime",
    "settings.alertAudioEnabledNote": "Play a sound when a price alert is triggered.",
    "settings.resetKicker": "Reset",
    "settings.resetNote": "Reset restores the default pane layout and indicator params. The visible pane limit can be adjusted again from Layout.",
    "pane.price": "Price",
    "pane.volume": "Volume",
    "pane.momentum": "RSI+MACD",
    "pane.orderflow": "Order Flow",
    "pane.strength": "Strength",
    // ── Indicator Sets ────────────────────────────────────────────────
    "settings.indicatorSets": "Indicator Sets",
    "settings.indicatorSetsTitle": "Manage indicator sets",
    "settings.indicatorSetsKicker": "Indicator Sets",
    "settings.builtinSets": "Built-in Templates",
    "settings.builtinSetsTitle": "Built-in templates",
    "settings.mySets": "My Sets",
    "settings.mySetsTitle": "Saved sets",
    "settings.noUserSets": "No saved sets yet",
    "settings.saveCurrentSet": "Save current configuration",
    "settings.setName": "Set name",
    "settings.setNamePlaceholder": "Enter set name...",
    "settings.defaultSetName": "New indicator set",
    "settings.importSet": "Import from file",
    "settings.setFileHint": "Supports .vnsc-set files",
    "settings.setPaneCount": "{count} panes",
    "settings.applySet": "Apply",
    "settings.exportSet": "Export",
    "settings.deleteSet": "Delete",
    "settings.setSaved": "Saved set \"{name}\"",
    "settings.setApplied": "Applied set \"{name}\"",
    "settings.setDeleted": "Deleted set \"{name}\"",
    "settings.setImported": "Imported set \"{name}\"",
    "settings.importError": "Invalid or malformed file",
    "indicatorSet.vnSwingSetup": "VN Swing Setup",
    "indicatorSet.emaMulti": "Multi EMA",
    "indicatorSet.orderflowSuite": "Orderflow Suite",
    "indicatorSet.cryptoStandard": "Crypto Standard",
    "settings.seriesMeta": "{count} indicators · {ratio}%",
    "settings.dataAdapter": "Data Adapter",
    "settings.dataAdapterKicker": "Data Adapter",
    "settings.dataAdapter.vnstocks": "VNStocks (coming soon)",
    // CE25: Drawings section
    "settings.drawingsKicker": "Drawings",
    "settings.manageDrawings": "Manage Drawings",
    "settings.syncTimeframes": "Sync across timeframes",
    "settings.syncTimeframesNote": "Drawings created on one timeframe will appear on all timeframes for the same symbol.",
    "settings.visibilityControls": "Visibility controls",
    "settings.visibilityControlsNote": "Control drawing visibility per timeframe and symbol.",
    "settings.drawingsSectionNote": "Drawings are saved per symbol. Use the Object Tree in the Drawing Dock to manage individual drawings.",
    "settings.enabled": "Enabled",
    "settings.disabled": "Disabled",
    // CE25: DrawingListPanel bulk operations
    "drawing.bulkDelete": "Bulk Delete",
    "drawing.bulkGroup": "Bulk Group",
    "drawing.bulkLock": "Bulk Lock",
    "drawing.bulkUnlock": "Bulk Unlock",
    "drawing.bulkHide": "Bulk Hide",
    "drawing.bulkShow": "Bulk Show",
    "drawing.groupBy": "Group by",
    "drawing.groupByType": "Type",
    "drawing.groupByGroupId": "Group ID",
    "drawing.selectAll": "Select All",
    "drawing.deselectAll": "Deselect All",
    "snapshot.preview.title": "Snapshot Preview",
    "snapshot.preview.save": "Save Image",
    "snapshot.preview.cancel": "Cancel",
    // CE29 additions: Templates, Alerts, Pine Editor, Bottom tabs, Strategy Tester
    "ui.template.name": "Enter template name:",
    "ui.template.noTemplates": "No saved templates found",
    "ui.template.select": "Enter template name to load:",
    "ui.template.notFound": "Template not found",
    "ui.alert.create": "Create Alert",
    "ui.alert.condition": "Condition",
    "ui.alert.crossing": "Crossing",
    "ui.alert.crossingUp": "Crossing Up",
    "ui.alert.crossingDown": "Crossing Down",
    "ui.alert.actions": "Actions",
    "ui.alert.webhook": "Webhook URL",
    "ui.bottomTab.strategyTester": "Strategy Tester",
    "ui.bottomTab.pineEditor": "Pine Editor",
    "ui.bottomTab.paperTrade": "Paper Trading",
    "ui.bottomTab.resizeHandle": "Drag to resize panel height",
    "ui.pinescript.editor": "Pine Editor",
    "ui.pinescript.compile": "Save and Add to Chart",
    "ui.pinescript.success": "Compiled successfully! Added to chart.",
    "ui.pinescript.visuals": "Visuals",
    "ui.pinescript.visuals.bar": "bar {n}",
    "ui.pinescript.visuals.fillBgcolor": "{n} fill/bgcolor",
    // P0-2 (2026-10-22): script strategy được validate bằng engine strategy.
    "ui.pinescript.strategyValidated": "Strategy compiled. Run it in the Strategy Tester.",
    "ui.pinescript.strategyNeedsBars": "A strategy needs price data to validate. Load a chart with data and compile again.",
    "ui.pinescript.error": "Compiler Error",
    "ui.pinescript.export": "Export .pine",
    "ui.pinescript.import": "Import .pine",
    "ui.pinescript.delete": "Delete",
    "ui.pinescript.rename": "Rename",
    "ui.pinescript.newScript": "New Script",
    "ui.pinescript.unsaved": "Unsaved",
    "ui.pinescript.saving": "Saving...",
    "ui.pinescript.saved": "Saved",
    "ui.pinescript.saveFailed": "Save failed",
    "ui.pinescript.confirmDelete": "Delete \"{name}\"?",
    "ui.pinescript.paneLimitReached": "Chart already shows the maximum number of panes. Close one, or set overlay=true in the script declaration.",
    "ui.pinescript.alreadyOnChart": "This script is already on the chart. Edit it from the pane header, or remove it first.",
    // PINE-09 (2026-10-12) + D-13 (2026-10-14): chuỗi sau từng hardcode tiếng Anh trong PineEditorPanel.tsx; `audit-hardcoded-text` chỉ soi tiếng Việt nên không bắt được.
    "ui.pinescript.statusCompiled": "Compiled",
    "ui.pinescript.statusError": "Error",
    "ui.pinescript.statusCompiling": "Compiling...",
    "ui.pinescript.workerError": "Worker error",
    "ui.pinescript.workerErrorDetail": "Worker error: {message}",
    "ui.pinescript.compileFailed": "Compilation failed.",
    "ui.pinescript.scriptList": "Scripts",
    "ui.pinescript.inputsTitle": "Parameters",
    "ui.pinescript.resetInputs": "Reset defaults",
    "ui.pinescript.importSuccess": "Imported \"{name}\"",
    "ui.pinescript.importFailed": "Import failed: invalid format",
    "ui.pinescript.cancel": "Cancel",
    "ui.pinescript.loadingEditor": "Loading editor...",
    "ui.indicator.settings.source.price": "Price",
    "ui.indicator.settings.source.indicators": "Indicator",
    "ui.indicator.settings.source": "Input Source",
    "ui.indicator.settings.timeframe": "Timeframe",
    "ui.indicator.settings.timeframe.sameAsChart": "Same as chart",
    "settings.seriesColor": "Color",
    "ui.alert.greaterThan": "Greater Than",
    "ui.alert.lessThan": "Less Than",
    "ui.alert.value": "Value",
    "ui.alert.price": "Price",
    "ui.alert.indicator": "Indicator",
    "ui.alert.frequency": "Frequency",
    "ui.alert.once": "Only Once",
    "ui.alert.oncePerBar": "Once Per Bar",
    "ui.alert.oncePerBarClose": "Once Per Bar Close",
    "ui.alert.continuous": "Continuous",
    "ui.alert.message": "Alert Message",
    "ui.alert.activeAlerts": "Active Alerts",
    "ui.alert.noAlerts": "No alerts configured.",
    "ui.alert.delete": "Delete",
    "ui.alert.reset": "Reset",
    "ui.alert.active": "Active",
    "ui.alert.deliveryFailed": "Webhook delivery failed",
    "ui.alert.deliveryFailedAt": "at {time}",
    "ui.alert.deliveryNotConfigured": "No webhook configured",
    // ── SaaS Premium Feature Gate ──────────────────────────────────────
    "premium.loading": "Checking access permissions...",
    "premium.invalidToken": "Invalid Token",
    "premium.invalidTokenDesc": "Please provide a valid PAT token to use this feature.",
    "premium.isWhalePanelEnabled.title": "Whale Flow Feature",
    "premium.isWhalePanelEnabled.description": "This feature is only available for Pro plans and above.",
    "premium.isReplayEnabled.title": "Market Replay Feature",
    "premium.isReplayEnabled.description": "This feature is only available for Pro plans and above.",
    // `PremiumFeatureGate.feature` is typed `keyof SaaSFeatureFlags`, so every flag can be passed; without these a future caller gating the advisory panel would render the raw key to the user.
    "premium.isAdvisoryEnabled.title": "Advisory Feature",
    "premium.isAdvisoryEnabled.description": "This feature is only available for Pro plans and above.",
    "premium.upgrade": "Upgrade Now",
    "saas.sessionExpired": "Session expired or access denied. Please reload the page.",
    "saas.invalidToken": "Invalid or unsupported token",
    // Ads
    "ads.close": "Close",
    "ads.imageAlt": "VNInvest Advertisement",
    "ads.title": "Unlock Pro Analysis Features",
    "ads.description": "You are using the free version of VNInvestCharts. Upgrade your account to access whale data and unlimited market replays.",
    "ads.upgrade": "Learn about Pro",
    "ads.closeCountdown": "Close ({countdown}s)",
    // Trademark
    "trademark.tamperDetected": "Trademark Tamper Detected",
    "trademark.tamperDescription": "The widget requires the \"Powered by VNInvest\" label to be displayed to function. Please restore the label to continue using.",
    "trademark.restore": "Restore and Continue",
    "trademark.ariaLabel": "Powered by VNInvest - Click to visit website",
    // Unified Header (Phase 2 Slice 1)
    "header.symbol.label": "Symbol",
    "header.symbol.placeholder": "Search symbol...",
    "header.timeframe.label": "Timeframe",
    "header.chartType.label": "Chart Type",
    "header.chartType.options": "Chart type options",
    "header.sync.groupLabel": "Synchronization settings",
    "header.sync.visibleRange": "Visible Range",
    "header.sync.crosshair": "Crosshair",
    "header.sync.timeframe": "Timeframe",
    "header.sync.chartType": "Chart Type",
    "header.sync.symbolLinks": "Symbol Links",
    "header.sync.drawings": "Drawings",
    "header.sync.replay": "Replay Sync",
    "header.drawingTools.label": "Drawing tools",
    "header.drawingTools.menuLabel": "Drawing tools menu",
    "header.drawingTools.trendline": "Trendline",
    "header.drawingTools.hline": "Horizontal Line",
    "header.drawingTools.vline": "Vertical Line",
    "header.drawingTools.ray": "Ray",
    "header.drawingTools.fibonacci": "Fibonacci",
    "header.drawingTools.pitchfork": "Pitchfork",
    "header.drawingTools.text": "Text",
    "header.drawingTools.measure": "Measure",
    "header.systemMenu.label": "System menu",
    // System Menu
    "systemMenu.workspace.title": "Workspace",
    "systemMenu.workspace.dropdownLabel": "Workspace options",
    "systemMenu.workspace.current": "Current:",
    "systemMenu.workspace.untitled": "Untitled Workspace",
    "systemMenu.workspace.new": "New Workspace",
    "systemMenu.workspace.newPlaceholder": "Enter workspace name...",
    "systemMenu.workspace.save": "Save",
    "systemMenu.workspace.cancel": "Cancel",
    "systemMenu.workspace.export": "Export workspace",
    "systemMenu.workspace.delete": "Delete workspace",
    "systemMenu.workspace.deleteConfirm": "Delete this workspace?",
    "systemMenu.workspace.empty": "No workspaces saved",
    "systemMenu.workspace.import": "Import Workspace",
    "systemMenu.layout.title": "Layout",
    "systemMenu.layout.dropdownLabel": "Layout presets",
    "systemMenu.layout.custom": "Custom",
    "systemMenu.layout.designer": "Layout Designer",
    "systemMenu.sync.title": "Synchronization",
    "systemMenu.sync.dropdownLabel": "Sync settings",
    "systemMenu.export.snapshot": "Export Snapshot",
    "systemMenu.export.data": "Export Data",
    "systemMenu.theme.title": "Theme",
    "systemMenu.theme.modern-light": "Modern Light",
    "systemMenu.theme.neutral-pro": "Neutral Pro",
    "systemMenu.theme.classic-dark": "Classic Dark",
    "systemMenu.theme.trading-night": "Trading Night",
    "systemMenu.theme.high-contrast": "High Contrast",
    "systemMenu.settings.title": "Settings",
    "settings.themeStudio.title": "Theme Studio",
    "settings.themeStudio.grid": "Grid",
    "settings.themeStudio.gridDensity": "Grid density",
    "settings.themeStudio.crosshair": "Crosshair",
    "settings.themeStudio.candleUp": "Candle Up",
    "settings.themeStudio.candleDown": "Candle Down",
    "settings.themeStudio.reset": "Reset",
    // Drawing Tools section (SystemMenu)
    "systemMenu.drawingTools.title": "Drawing Tools",
    "systemMenu.drawingTools.dropdownLabel": "Drawing tools options",
    "systemMenu.drawingTools.none": "None",
    // Context indicator
    "systemMenu.context.workspace": "Workspace Mode",
    "systemMenu.context.chart": "Chart Mode",
    // Upgrade section
    "systemMenu.upgrade.title": "Upgrade to Pro",
    "systemMenu.upgrade.desc": "Get access to all features",
    // Toolbar extras
    "toolbar.favorites": "Favorites",
    "toolbar.undo": "Undo",
    "toolbar.redo": "Redo",
    "toolbar.clearAll": "Clear All",
    "toolbar.clearAllConfirmTitle": "Clear all drawings",
    "toolbar.clearAllConfirmMessage": "Delete {count} drawings? Press Ctrl+Z to undo after clearing.",
    "toolbar.clearAllConfirm": "Clear all",
    "toolbar.clearAllDone": "Cleared {count} drawings — press Ctrl+Z to undo",
    "toolbar.cancel": "Cancel",
    // Tier gate (multi-chart layout cap)
    "tierGate.message": "This layout needs {required} charts (your plan allows {max})",
    "tierGate.upgrade": "Upgrade",
    "tier.downgrade.message": "Premium drawings temporarily hidden due to tier change.",
    // S4: magnet shortcut hint
    "toolbar.magnet": "Magnet",
    // Tool group labels
    "toolbar.group.cursors": "Cursors",
    "toolbar.group.trend": "Trend Lines",
    "toolbar.group.horizontal": "Horizontal & Vertical",
    "toolbar.group.fibonacci": "Fibonacci",
    "toolbar.group.patterns": "Patterns",
    "toolbar.group.shapes": "Shapes",
    "toolbar.group.annotations": "Annotations",
    "toolbar.group.measure": "Measure",
    // Chart Types
    "chartType.heikinAshi": "Heikin Ashi",
    "chartType.renko": "Renko",
    "chartType.kagi": "Kagi",
    "chartType.pointAndFigure": "Point & Figure",
    "chartType.lineBreak": "Line Break",
    "chartType.baseline": "Baseline",
    "chartType.proLocked": "Pro", "chartType.comingSoon": "Coming soon",
    // Keyboard Shortcuts
    "shortcuts.symbolSearch": "Search Symbol",
    "shortcuts.timeframeNext": "Next Timeframe",
    "shortcuts.timeframePrev": "Previous Timeframe",
    "shortcuts.chartTypeCycle": "Cycle Chart Type",
    "shortcuts.toggleSyncVisibleRange": "Toggle Sync Visible Range",
    "shortcuts.toggleSyncCrosshair": "Toggle Sync Crosshair",
    "shortcuts.openSystemMenu": "Open System Menu",
    "shortcuts.toggleDrawingTools": "Toggle Drawing Tools",
    "shortcuts.undoRedo": "Undo / Redo",
    "shortcuts.removeDrawing": "Remove selected drawing",
    "shortcuts.copyPaste": "Copy / paste drawing",
    "shortcuts.lockHide": "Lock / hide selected",
    "shortcuts.cursorCancel": "Cursor tool / cancel",
    "shortcuts.thisHelp": "This help",
    // P0: các phím ĐANG CHẠY nhưng trước đây không được liệt kê trong help modal.
    "shortcuts.dockToggle": "Toggle right dock", "shortcuts.syncToggles": "Toggle sync crosshair / visible range", "shortcuts.toggleFavorites": "Toggle drawing favorites bar", "shortcuts.paperTrading": "Paper trading: buy / sell / close", "shortcuts.replay": "Replay: play-pause / step", "shortcuts.maximizeCell": "Maximize active grid cell",
    // Layout Designer
    "layoutDesigner.title": "Layout Designer",
    "layoutDesigner.saveAsPreset": "Save as Preset",
    "layoutDesigner.rows": "Rows",
    "layoutDesigner.cols": "Cols",
    "layoutDesigner.addRow": "Add Row",
    "layoutDesigner.addCol": "Add Col",
    "layoutDesigner.splitHorizontal": "Split Horizontally",
    "layoutDesigner.splitVertical": "Split Vertically",
    "layoutDesigner.resizeTop": "Resize Top",
    "layoutDesigner.resizeRight": "Resize Right",
    "layoutDesigner.resizeBottom": "Resize Bottom",
    "layoutDesigner.resizeLeft": "Resize Left",
    "layoutDesigner.savePresetTitle": "Save as Preset",
    "layoutDesigner.presetNamePlaceholder": "Enter preset name",
    "layoutDesigner.savePresetFailed": "Could not save the layout preset. Please try again.",
    "layoutDesigner.savedPresets": "Saved presets",
    "layoutDesigner.deletePreset": "Delete preset",
    // Presets
    "presets.1x1": "1x1",
    "presets.1x2": "1x2",
    "presets.2x1": "2x1",
    "presets.2x2": "2x2",
    "presets.1x4": "1x4",
    "presets.4x1": "4x1",
    "presets.2x4": "2x4",
    "presets.lShape": "L-Shape",
    "presets.lShapeDesc": "Large main chart with two stacked charts on the side",
    "presets.tShape": "T-Shape",
    "presets.tShapeDesc": "Wide main chart with three charts below",
    "presets.main3Sidebar": "Main + 3 Sidebar",
    "presets.main3SidebarDesc": "Tall main chart with three sidebar charts",
    "presets.quadFocus": "Quad + Focus",
    "presets.quadFocusDesc": "Large focus chart with four smaller charts around it",
    // Conflict Resolver
    "conflictResolver.title": "Drawing Conflicts",
    "conflictResolver.concurrentEdit": "Concurrent edits detected",
    "conflictResolver.deleteVsEdit": "One user deleted while another edited",
    "conflictResolver.moveVsEdit": "Point moved while drawing was edited",
    "conflictResolver.unknown": "Unknown conflict",
    "conflictResolver.noVersionDiff": "No version differences",
    "conflictResolver.details": "Conflict Details",
    "conflictResolver.localVersion": "Local Version",
    "conflictResolver.remoteVersion": "Remote Version",
    "conflictResolver.keepLocal": "Keep Local",
    "conflictResolver.keepRemote": "Keep Remote",
    "conflictResolver.merge": "Merge",
    "conflictResolver.dismiss": "Dismiss",
    // ── Mobile Layout ────────────────────────────────────────────────
    "mobile.timeframe": "Timeframe",
    "mobile.chartType": "Chart Type",
    "mobile.compare": "Compare",
    "mobile.closeCompare": "Close Compare",
    "mobile.replay": "Replay",
    "mobile.pauseReplay": "Pause Replay",
    "mobile.selectChart": "Select Chart",
    "mobile.drawingTools": "Drawing Tools",
    "mobile.layout": "Layout",
    "mobile.sync": "Sync",
    "mobile.syncVisibleRange": "Sync visible range",
    "mobile.syncCrosshair": "Sync crosshair",
    "mobile.syncDrawings": "Sync drawings",
    "mobile.syncSymbolLinks": "Sync symbol links",
    "mobile.syncTimeframe": "Sync timeframe",
    "mobile.syncChartType": "Sync chart type",
    "mobile.syncReplay": "Sync replay",
    "mobile.syncTime": "Sync time anchor (keep zoom)",
    "mobile.features": "Features",
    "mobile.pineEditor": "Pine Editor",
    "mobile.strategyTester": "Strategy Tester",
    "mobile.chartActions": "Chart Actions",
    "mobile.addChart": "Add Chart",
    "mobile.saveWorkspace": "Save workspace",
    "topbar.layoutTitle": "Chart layout",
    "topbar.noChartHint": "Select a chart cell to configure symbol/timeframe",
    "topbar.focusedChart": "Selected: {symbol} (Chart {index})",
    "legend.show": "Show",
    "legend.hide": "Hide",
    "legend.remove": "Remove from pane",
    "legend.edit": "Indicator settings",
    "footer.scale.group": "Price scale",
    "footer.scale.auto": "Auto",
    "footer.scale.log": "Log",
    "footer.scale.percent": "%",
    "footer.timezone": "Timezone",
    "footer.countdown": "Bar countdown",
    "footer.timeframeGroup": "Interval",
    "footer.rangeGroup": "Range",
    "footer.resetLayout": "Reset layout",
    "footer.resetConfirm": "Reset layout to default (Candles & Volume only)?",
    "datawindow.symbol": "Symbol",
    "datawindow.time": "Time",
    "datawindow.open": "Open",
    "datawindow.high": "High",
    "datawindow.low": "Low",
    "datawindow.close": "Close",
    "datawindow.volume": "Volume",
    "datawindow.change": "Change",
    "drawingTool.cursor": "Cursor",
    "drawingTool.crosshair": "Crosshair",
    "drawingTool.trendLine": "Trend Line",
    "drawingTool.ray": "Ray",
    "drawingTool.extendedLine": "Extended Line",
    "drawingTool.parallelChannel": "Parallel Channel",
    "drawingTool.hLine": "Horizontal Line",
    "drawingTool.vLine": "Vertical Line",
    "drawingTool.priceLine": "Price Line",
    // Ids below are the CANONICAL tool ids (engine overlay layer + @vninvestcharts/engine-drawing/builtin).
    // MobileToolbar/ShortcutHelpModal build `drawingTool.${id}`, so a gap renders a raw key.
    "drawingTool.priceLabel": "Price Label",
    "drawingTool.fibonacci": "Fib Retracement",
    "drawingTool.fibExtension": "Fib Extension",
    "drawingTool.fibChannel": "Fib Channel",
    "drawingTool.fibTimeZone": "Fib Time Zones",
    "drawingTool.dateAndPriceRange": "Date & Price Range",
    "drawingTool.fibonacciExtension": "Fib Extension",
    "drawingTool.fibonacciChannel": "Fib Channel",
    "drawingTool.fibonacciTime": "Fib Time Zones",
    "drawingTool.pitchfork": "Pitchfork",
    "drawingTool.schiffPitchfork": "Schiff Pitchfork",
    "drawingTool.gannBox": "Gann Box",
    "drawingTool.gannFan": "Gann Fan",
    "drawingTool.brush": "Brush",
    "drawingTool.rectangle": "Rectangle",
    "drawingTool.ellipse": "Ellipse",
    "drawingTool.triangle": "Triangle",
    "drawingTool.arc": "Arc",
    "drawingTool.text": "Text",
    "drawingTool.callout": "Callout",
    "drawingTool.arrow": "Arrow",
    "drawingTool.measure": "Measure",
    "drawingTool.dateRange": "Date Range",
    "drawingTool.priceRange": "Price Range",
    "drawingTool.eraser": "Eraser",
    "drawingTool.polygon": "Polygon",
    "drawingTool.longPosition": "Long Position",
    "drawingTool.shortPosition": "Short Position",
    "drawingTool.toggleMagnet": "Toggle magnet",
    "grid.splitter.resizeRow": "Resize row {row}",
    "grid.splitter.resizeColumn": "Resize column {column}",
    "grid.splitter.resetTracks": "Double-click to reset sizes",
    "grid.splitter.valuePercent": "{percent}%",
    "pane.splitter.tooltip": "Drag to resize pane • Double-click to equalize",
    "pane.splitter.ariaLabel": "Pane resize splitter, row {index}",
    "pane.splitter.badgeTop": "Top",
    "pane.splitter.badgeBottom": "Bottom",
    "crosshair.mode.label": "Crosshair mode",
    "crosshair.mode.crossTitle": "Cross crosshair",
    "crosshair.mode.dotTitle": "Dot crosshair (value beacon only)",
    "crosshair.mode.magnetTitle": "Magnet crosshair (snap to OHLC)",
    "priceScale.menuTitle": "Price scale",
    "priceScale.auto": "Auto",
    "priceScale.log": "Logarithmic",
    "priceScale.percent": "Percent",
    "priceScale.resetZoom": "Reset price zoom",
    "priceScale.logUnavailable": "Log scale needs positive prices",
    "scrollbar.windowLabel": "Visible range navigator",
    "scrollbar.valuePercent": "{percent}% visible",
    "statusLine.collapse": "Collapse status line",
    "statusLine.expand": "Expand status line",
    "statusLine.hideSeries": "Hide series",
    "statusLine.showSeries": "Show series",
    "statusLine.settings": "Settings",
    "statusLine.remove": "Remove",
    "statusLine.countdown": "Bar countdown",
    // ── Chart Settings Tabs & Controls ──────────────────────────────
    "settings.title": "Chart Settings",
    "settings.searchPlaceholder": "Search settings...",
    "settings.restoreDefaults": "Restore defaults",
    "settings.cancel": "Cancel",
    "settings.apply": "Apply",
    "settings.tab.symbol": "Symbol & Candles",
    "settings.tab.statusLine": "Status Line",
    "settings.tab.scales": "Scales & Coordinates",
    "settings.tab.appearance": "Appearance & Canvas",
    "settings.tab.panes": "Panes Layout",
    "settings.tab.indicators": "Indicators",
    "settings.tab.trading": "Trading & Events",
    "settings.tab.theme": "Theme & Colors",
    "settings.tab.licensing": "Licensing",
    "settings.tab.reset": "Reset to Default",
    "settings.symbol.candleStyle": "Chart style",
    "settings.symbol.chartStyle": "Chart style",
    "settings.symbol.style": "Display style",
    "settings.styleBar": "Bar",
    "settings.styleLine": "Line",
    "settings.symbol.colors": "Candle colors",
    "settings.symbol.body": "Body",
    "settings.symbol.borders": "Borders",
    "settings.symbol.wick": "Wick",
    "settings.symbol.up": "Up",
    "settings.symbol.down": "Down",
    "settings.symbol.upColor": "Up candle color",
    "settings.symbol.downColor": "Down candle color",
    "settings.symbol.priceLines": "Price lines",
    "settings.symbol.lastPriceLine": "Last price line",
    "settings.symbol.prevClosePriceLine": "Previous close price line",
    "settings.symbol.highLowPriceLines": "High and low price lines",
    "settings.symbol.general": "General configuration",
    "settings.symbol.precision": "Decimal precision",
    "settings.symbol.precision.default": "Default",
    "settings.symbol.timezone": "Timezone",
    "settings.statusLine.symbol": "Symbol information",
    "settings.statusLine.logo": "Company logo",
    "settings.statusLine.showLogo": "Show company logo",
    "settings.statusLine.ticker": "Symbol ticker",
    "settings.statusLine.showTicker": "Show symbol ticker",
    "settings.statusLine.ohlc": "OHLC values",
    "settings.statusLine.showOhlc": "Show OHLC values",
    "settings.statusLine.barChange": "Bar change values",
    "settings.statusLine.showBarChange": "Show bar change values",
    "settings.statusLine.volume": "Volume",
    "settings.statusLine.showVolume": "Show volume",
    "settings.statusLine.indicators": "Indicators on status line",
    "settings.statusLine.indicatorTitles": "Indicator titles",
    "settings.statusLine.showIndicatorTitles": "Show indicator titles",
    "settings.statusLine.indicatorArguments": "Indicator arguments",
    "settings.statusLine.showIndicatorArguments": "Show indicator arguments",
    "settings.statusLine.indicatorValues": "Indicator values",
    "settings.statusLine.showIndicatorValues": "Show indicator values",
    "settings.statusLine.appearance": "Status line appearance",
    "settings.statusLine.bgOpacity": "Background opacity",
    "settings.statusLine.backgroundOpacity": "Background opacity",
    "settings.scales.priceScale": "Price scale (Y-Axis)",
    "settings.scales.priceScaleMode": "Scale mode",
    "settings.scales.mode": "Scale mode",
    "settings.scales.mode.normal": "Normal",
    "settings.scales.mode.log": "Logarithmic",
    "settings.scales.mode.percentage": "Percentage",
    "settings.scales.normal": "Normal",
    "settings.scales.logarithmic": "Logarithmic",
    "settings.scales.percentage": "Percentage",
    "settings.scales.invertScale": "Invert scale",
    "settings.scales.axisPosition": "Price axis position",
    "settings.scales.right": "Right",
    "settings.scales.left": "Left",
    "settings.scales.labels": "Scale labels",
    "settings.scales.showSymbolLastValue": "Symbol last value label",
    "settings.scales.showPrevCloseValue": "Previous day close value label",
    "settings.scales.showIndicatorValues": "Indicator value labels",
    "settings.scales.countdown": "Countdown to close",
    "settings.scales.showCountdown": "Countdown to bar close",
    "settings.scales.timeAxis": "Time axis (X-Axis)",
    "settings.scales.timeScrollbar": "Time scrollbar",
    "settings.scales.showScrollbar": "Time navigation scrollbar",
    "settings.scales.showScrollbarNote": "Show slider/slice navigation bar for visible range below X-axis",
    "settings.scales.dateFormat": "Date format",
    "settings.scales.timeFormat": "Time format",
    "settings.appearance.background": "Background",
    "settings.appearance.bgType": "Background type",
    "settings.appearance.solid": "Solid",
    "settings.appearance.gradient": "Gradient",
    "settings.appearance.bgColor": "Background color",
    "settings.appearance.gradientColors": "Gradient colors (Top / Bottom)",
    "settings.appearance.grid": "Grid lines",
    "settings.appearance.vertGrid": "Vertical grid",
    "settings.appearance.horzGrid": "Horizontal grid",
    "settings.appearance.crosshair": "Crosshair",
    "settings.appearance.crosshairMode": "Crosshair mode",
    "settings.appearance.crosshairColor": "Crosshair color",
    "settings.appearance.watermark": "Symbol watermark",
    "settings.appearance.watermarkAndFont": "Watermark & Scales font",
    "settings.appearance.showWatermark": "Symbol watermark",
    "settings.appearance.scalesFont": "Scales font size",
    "settings.appearance.scalesFontSize": "Scales font size",
    "settings.panes.maxPanes": "Max visible panes",
    "settings.panes.showNonTrading": "Show non-trading days",
    "settings.overlay": "Multi-timeframe overlay",
    "settings.panes.overlayTimeframe": "Overlay timeframe",
    "settings.panes.overlayStyle": "Overlay candle style",
    "settings.paneNamePlaceholder": "Pane name...",
    "settings.workspaceJsonDesc": "Export or import layout configuration including panes and indicators",
    "settings.panes.exportWorkspace": "Export JSON",
    "settings.panes.importWorkspace": "Import JSON",
    "settings.indicatorsCount": "indicators",
    "settings.noIndicatorsInPane": "No indicators in this pane. Add one below.",
    "settings.addSeries": "+ Add indicator",
    "settings.builtin": "Built-in",
    "settings.custom": "Custom",
    "common.save": "Save",
    "settings.priceClose": "Close",
    "settings.priceOpen": "Open",
    "settings.priceHigh": "High",
    "settings.priceLow": "Low",
    "settings.priceVolume": "Volume",
    "settings.lineWidth": "Line width",
    "settings.trading.corporateEvents": "Corporate events",
    "settings.trading.showCorporateEvents": "Show corporate events on chart",
    "settings.trading.showCorporateEventsNote": "Mark dividends (D) and stock splits (S) on candles",
    "settings.trading.whaleFlow": "Whale flow",
    "settings.trading.enableWhale": "Enable whale trade detection",
    "settings.trading.enableWhaleNote": "Highlight orders with abnormal volume",
    "settings.trading.whaleThreshold": "Whale trade threshold (VND)",
    "settings.trading.cvd": "Cumulative Volume Delta (CVD)",
    "settings.trading.enableCVD": "Show CVD indicator",
    "settings.trading.cvdMode": "CVD display mode",
    "settings.trading.cvdOscillator": "Oscillator",
    "settings.trading.cvdHistogram": "Histogram",
    "settings.trading.alertsAndPaper": "Alerts & Paper trading",
    "settings.trading.alertAudio": "Play audio alert when price trigger fires",
    "settings.trading.alertChime": "Alert chime",
    "settings.trading.showPaperOrders": "Show pending Paper Trading order lines on chart",
    "settings.trading.showPaperPositions": "Show open positions and Stoploss/Takeprofit lines",
    "settings.trading.paperMarkers": "Paper trading markers",
    "settings.trading.dataSource": "Data source",
    "settings.theme.mode": "Theme mode",
    "settings.theme.activeMode": "Active mode",
    "settings.theme.dark": "Dark",
    "settings.theme.light": "Light",
    "settings.theme.presets": "Theme presets",
    "settings.theme.palette": "Candle color palette",
    "settings.theme.restoreTheme": "Reset theme colors",
    "widget.trading.buy": "Buy",
    "widget.trading.sell": "Sell",
    "widget.trading.market": "Market",
    "widget.trading.limit": "Limit",
    "widget.trading.stop": "Stop",
    "widget.trading.quantity": "Quantity",
    "widget.trading.price": "Price",
    "widget.trading.stopPrice": "Stop price",
    "widget.trading.takeProfit": "Take profit",
    "widget.trading.stopLoss": "Stop loss",
    "widget.trading.trailingDelta": "Trail (ticks)",
    "widget.trading.timeInForce": "Time in force",
    "widget.trading.gtc": "GTC",
    "widget.trading.buyingPower": "Buying power",
    "widget.trading.requiredMargin": "Required margin",
    "widget.trading.riskReward": "R:R ratio",
    "widget.trading.estProfit": "Est. profit",
    "widget.trading.estLoss": "Est. loss",
    "widget.trading.accountRisk": "Account risk",
    "widget.trading.oneClick": "One-click",
    "widget.trading.syntheticQuoteHint": "Synthetic Bid/Ask derived from candles (not a real order book)",
    "widget.trading.orderTicket": "Order ticket",
    "widget.trading.placeOrder": "Place order",
    "widget.trading.cancel": "Cancel",
    "widget.trading.close": "Close",
    "widget.trading.lots": "lots",
    "widget.trading.contracts": "contracts",
    "widget.trading.ticketBuyTitle": "Buy {symbol}",
    "widget.trading.ticketSellTitle": "Sell {symbol}",
    "widget.trading.insufficientBuyingPower": "Insufficient buying power",
    "widget.trading.invalidQuantity": "Invalid quantity",
    "widget.trading.shortNotAllowed": "Short selling not allowed",
    "widget.trading.noQuote": "No quote",
    "widget.trading.confirmCloseTitle": "Quick close position",
    "widget.trading.confirmCloseMessage": "Close {quantity} {symbol} at market?",
    "widget.trading.confirm": "Confirm",
    "widget.trading.long": "Long",
    "widget.trading.short": "Short",
    "widget.trading.closePosition": "Close position",
    "widget.trading.closeAllPositions": "Close all positions",
    "widget.trading.reversePosition": "Reverse position",
    "widget.trading.cancelOrder": "Cancel order",
    "widget.trading.newPrice": "New price",
    "widget.trading.positions": "Positions",
    "widget.trading.orders": "Orders",
    "widget.trading.history": "History",
    "widget.trading.summary": "Overview",
    "widget.trading.log": "Log",
    "widget.trading.symbol": "Symbol",
    "widget.trading.side": "Side",
    "widget.trading.entryPrice": "Entry",
    "widget.trading.markPrice": "Mark",
    "widget.trading.availability": "Status",
    "widget.trading.available": "Available",
    "widget.trading.awaitingSettlement": "Settling (T+2)",
    "widget.trading.orderType": "Type",
    "widget.trading.orderPrice": "Price",
    "widget.trading.triggerPrice": "Trigger",
    "widget.trading.orderTime": "Placed",
    "widget.trading.fillPrice": "Fill",
    "widget.trading.commission": "Fee",
    "widget.trading.tax": "Tax",
    "widget.trading.exitReason": "Exit",
    "widget.trading.time": "Time",
    "widget.trading.totalTrades": "Total trades",
    "widget.trading.winRate": "Win rate",
    "widget.trading.profitFactor": "Profit factor",
    "widget.trading.netProfit": "Net profit",
    "widget.trading.maxDrawdown": "Max drawdown",
    "widget.trading.balance": "Cash",
    "widget.trading.equity": "Equity",
    "widget.trading.unrealizedPnl": "Open PnL",
    "widget.trading.marginLevel": "Margin level",
    "widget.trading.reset": "Reset",
    "widget.trading.closePanel": "Close panel",
    "widget.trading.paperTrading": "Paper Trading",
    "widget.trading.reverse": "Reverse",
    "widget.trading.noPositions": "No open positions",
    "widget.trading.emptyPositionsHint": "Place orders directly on chart or press Shift + B to open ticket",
    "widget.trading.marginSafe": "Safe",
    "widget.trading.marginWarning": "Warning",
    "widget.trading.marginDanger": "Danger",
    "widget.trading.refillTitle": "Deposit paper capital",
    "widget.trading.refillMessage": "Reset the account back to the capital you enter.",
    "widget.trading.refillAmount": "Capital",
    "widget.trading.refillInvalid": "Enter an amount from 1 to 1,000,000,000,000",
    "widget.trading.paperVisibilityActive": "Show Paper Trading on",
    "widget.trading.paperVisibilityActiveNote": "Applies to the selected chart only",
    "widget.trading.noOrders": "No working orders",
    "widget.trading.noHistory": "No fill history",
    "widget.trading.resetConfirmTitle": "Reset account?",
    "widget.trading.resetConfirmMessage": "Clear all positions, orders and history back to initial balance?",
    "ui.bottomTab.paperTrading": "Paper Trading",
    "widget.trading.save": "Save",
    "widget.trading.editOrder": "Edit order",
    "widget.trading.orderHistory": "Order history",
    "widget.trading.tradeHistory": "Trade history",
    "widget.trading.noTrades": "No closed positions",
    "widget.trading.orderStatus": "Status",
    "widget.trading.statusFilled": "Filled",
    "widget.trading.statusCancelled": "Cancelled",
    "widget.trading.statusRejected": "Rejected",
    "widget.trading.spread": "Spread",
    "widget.trading.enablePaperTrading": "Enable paper trading",
    "widget.trading.paperTradingOff": "Paper trading is off",
    "widget.trading.paperTradingOffHint": "Enable to see quotes, place orders and drag SL/TP on the chart",
    "widget.trading.dragToMove": "Drag to move",
    "widget.trading.resetPosition": "Double-click to reset position",
    "widget.trading.realizedPnl": "Realized PnL",
    "widget.trading.accountMargin": "Account margin",
    "widget.trading.availableFunds": "Available funds",
    "widget.trading.ordersMargin": "Orders margin",
    "widget.trading.sharpeRatio": "Sharpe ratio",
    "widget.trading.exportCsv": "Export CSV",
    "widget.trading.exitUnit": "TP/SL unit",
    "widget.trading.unitPrice": "Price",
    "widget.trading.unitTicks": "Ticks",
    "widget.trading.unitPercent": "% equity",
    "widget.trading.offsetFromMark": "Offset from market (ticks)",
    "widget.trading.paperVisibility": "Paper trading visibility",
    "widget.trading.paperMaster": "Enable for whole workspace",
    "widget.trading.paperPerChart": "Override per chart below",
    "widget.trading.hidePaperTrading": "Hide paper trading (re-enable in Settings)",
    "widget.trading.showPaperTrading": "Show paper trading",
    "toast.dismiss": "Dismiss notification",
    "error.retry": "Retry",
    "error.reload": "Reload chart",
    "error.dataFetch": "Could not load market data. Check your connection and retry.",
    "error.timeout": "The data request timed out. Retry in a moment.",
    "error.unknown": "Something went wrong. Retry or reload the chart.",
    "shortcuts.title": "Keyboard shortcuts",
    "shortcuts.hint": "Press ? anytime to reopen this help.",
    // Namespace tách riêng: mỗi file có ngưỡng fat-file riêng; catalog này đã ở trần nên không được thêm key trực tiếp (L-P01).
    ...dockMessagesEn, ...pricePaneMessagesEn, ...tradingMessagesEn,
    ...a11yMessagesEn, ...licensingMessagesEn, ...capabilityMessagesEn, ...settingsMessagesEn, ...strategyMessagesEn,
};
